import api from '@/api/users';
import store from '@/store';
import i18n from '@/i18n';
import * as types from './types';

export default {
  getUsers(context, searchResquest) {
    store.dispatch('application/startLoading');
    return api.getUsers(searchResquest)
      .then((data) => {
        context.commit(types.GET_USERS_SUCCESS, data);
        store.dispatch('application/finishLoading');
        return data;
      })
      .catch(() => {
        context.commit(types.GET_USERS_FAILED);
        store.dispatch('application/finishLoading');
      });
  },

  getUser(context, id) {
    store.dispatch('application/startLoading');
    return api.getUser(id)
      .then((data) => {
        store.dispatch('application/finishLoading');
        return data;
      })
      .catch(() => store.dispatch('application/finishLoading'));
  },

  updateUser(context, user) {
    store.dispatch('application/startLoading');
    return api.updateUser(user)
      .then((data) => {
        store.dispatch('application/finishLoading');
        store.dispatch('application/openSnackbar', {
          message: i18n.t('user.messages.update.success'),
        });
        return data;
      })
      .catch(() => {
        store.dispatch('application/finishLoading');
        store.dispatch('application/openSnackbar', {
          message: i18n.t('user.messages.update.error'),
        });
      });
  },

  changePassword(context, params) {
    store.dispatch('application/startLoading');
    return api.changePassword(params)
      .then(() => {
        store.dispatch('application/finishLoading');
        store.dispatch('application/openSnackbar', {
          message: i18n.t('user.messages.passwordChange.success'),
        });
      })
      .catch(() => {
        store.dispatch('application/finishLoading');
        store.dispatch('application/openSnackbar', {
          message: i18n.t('user.messages.passwordChange.error'),
        });
      });
  },

  reinitPassword(context, params) {
    store.dispatch('application/startLoading');
    return api.reinitUserPassword(params)
      .then((response) => {
        store.dispatch('application/finishLoading');
        return response;
      })
      .catch(() => {
        store.dispatch('application/finishLoading');
      });
  },

  getCurrentUser() {
    store.dispatch('application/startLoading');
    return api.getCurrentUser()
      .then((data) => {
        store.dispatch('application/finishLoading');
        return data.data.data;
      })
      .catch(() => store.dispatch('application/finishLoading'));
  },
};



// WEBPACK FOOTER //
// ./src/store/modules/users/actions.js